import React, { useState } from "react";
import { Checkbox, Grid, Slider } from "@material-ui/core";
import { fabric } from "fabric";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const BlurOptions = ({ save, saveBack }) => {
  const { t } = useTranslation();
  const _home = useSelector((state) => state.home);
  const [blur, setBlur] = useState(0);

  const applyFilter = (index, filter) => {
    var obj = _home.currentCanvas.getActiveObject();
    if (obj) {
      obj.filters[index] = filter;
      obj.applyFilters();
      _home.currentCanvas.requestRenderAll();
    }
    if (_home.face === "front") {
      save();
    } else {
      saveBack();
    }
  };

  const applyFilterValue = (index, prop, value) => {
    var obj = _home.currentCanvas.getActiveObject();
    if (obj.filters[index]) {
      obj.filters[index][prop] = value;
      obj.applyFilters();
      _home.currentCanvas.requestRenderAll();
    }
    if (_home.face === "front") {
      save();
    } else {
      saveBack();
    }
  };

  const applyBlur = (check) => {
    applyFilter(
      11,
      check &&
        new fabric.Image.filters.Blur({
          value: parseFloat(blur),
        })
    );
  };

  const handleValueChange = (event, newValue) => {
    setBlur(newValue);
    applyFilterValue(11, "blur", parseFloat(newValue, 10));
  };
  return (
    <div>
      {t("AlternateOptions.Blur")}
      <Checkbox
        color="primary"
        onClick={(e) => applyBlur(e.target.checked)}
        inputProps={{ "aria-label": "secondary checkbox" }}
      />
      <Grid container spacing={2} alignItems="center">
        <Grid item xs>
          <Slider
            step={0.01}
            min={0}
            max={1}
            value={typeof blur === "number" ? blur : 0}
            onChange={handleValueChange}
            aria-labelledby="input-slider"
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default BlurOptions;
